var map = {
	"./mobile/trade.vue": [
		"18b9",
		"chunk-793d4533",
		"chunk-227a49c3"
	],
	"./pc/trade.vue": [
		"3bec",
		"chunk-793d4533",
		"chunk-36b5819c"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "7ff0";
module.exports = webpackAsyncContext;